import { memo } from 'react'
import { MdHelp } from 'react-icons/md'

const UDDFooter = ({
    isUploadStep,
    batchUploadDocuments,
    shouldProcessDocs,
    setShouldProcessDocs,
    validUploadData,
    hasInsufficientBalance,
    paymentsEnabled,
    toggleUploadDocumentDialogOpen,
}) => {
    
    return (
        
        <div className="modal-footer w-full flex justify-between gap-4">
            
            {!isUploadStep && (
                <div className="flex flex-row items-center">
                    
                    <label className="flex items-center gap-1">
                        <input
                            type="checkbox"
                            className="checkbox checkbox-info checkbox-sm mr-2"
                            checked={shouldProcessDocs}
                            onChange={e => {
                                setShouldProcessDocs(e.target.checked)
                            }}/>
                        <span>Do you want to process the uploaded documents?</span>
                    </label>
                    
                    {paymentsEnabled &&
                        <MdHelp
                            data-tooltip-id="default-tip"
                            data-tooltip-content={`This action will 
                                        automatically discount from your credits!`}/>}
                
                </div>
            )}
            
            <div className="flex justify-end gap-2">
                
                <button
                    type="button"
                    className="btn btn-primary btn-outline"
                    onClick={toggleUploadDocumentDialogOpen}>
                    Cancel
                </button>
                
                <div
                    data-tooltip-id={validUploadData.length === 0 ? 'default-tip' : undefined}
                    data-tooltip-content={`You don't have any files to be uploaded. 
                        Please, check if any files above are selected.`}>
                    <button
                        className="btn btn-primary"
                        data-test-id="UploadDocumentPopUpSubmitButton"
                        disabled={validUploadData.length === 0 || hasInsufficientBalance}
                        onClick={batchUploadDocuments}>
                        Upload
                    </button>
                </div>
            
            </div>
        
        </div>
        
    )
    
}

export default memo(UDDFooter)
